/**
 * Properties can accumulate duplicate singleton underwriting rows (e.g. from
 * partial saves). Merge them for load: start from the newest row and backfill
 * null/empty fields from older rows.
 */
export function mergePropertySingletonRows(rows) {
    if (!Array.isArray(rows) || rows.length === 0) {
        return {};
    }
    const sorted = [...rows].sort((a, b) => Number(b.ARCIMEDES_ROW_ID) - Number(a.ARCIMEDES_ROW_ID));
    const merged = {...sorted[0]};
    for (let i = 1; i < sorted.length; i++) {
        Object.keys(sorted[i]).forEach(key => {
            const current = merged[key];
            if (current === null || current === undefined || current === '') {
                const fallback = sorted[i][key];
                if (fallback !== null && fallback !== undefined && fallback !== '') {
                    merged[key] = fallback;
                }
            }
        });
    }
    return merged;
}
